import React from 'react'
import { Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { loadDriver, clearDriver, deleteDriver } from '../../common/drivers/actions'
import { Title } from '../components'
import { DriverForm } from '../forms'
import { roles } from '../../common/config'

class DriverPage extends React.Component {
  componentDidMount() {
    const { match, loadDriver, driver } = this.props
    const { params } = match
    if (params.driver && (!driver._id || params.driver !== driver._id)) loadDriver(params.driver)
  }
  componentWillUnmount() {
    this.props.clearDriver()
  }
  onDelete() {
    if (window.confirm('Opravdu chcete smazat záznam řidiče ?')) {
      this.deleteDriver(this.driver._id)
      window.location = '/drivers'
    }
  }
  render() {
    const { match, driver, viewer } = this.props
    const { params } = match
    let driverForm = null
    if (params.driver) {
      if (driver._id) driverForm = <DriverForm driver={driver} role={viewer.role} attendSource={params.attendSource} />
    } else {
      driverForm = <DriverForm role={viewer.role} attendSource={params.attendSource} />
    }
    const title = driver._id ? driver.firstName + ' ' + driver.lastName : 'Nový řidič'
    return (
      <div>
        <Title message={title} />
        <aside className="breadcrumbs">
          <Link to="/drivers">Řidiči</Link>
          <img src="/images/arrow.png" alt="arrow-right" />
          <span>{title}</span>
          {!params.attendSource && driver._id &&
          <div className="options">
            { [roles.SUPERVISOR, roles.ADMIN].indexOf(viewer.role) !== -1 &&
              <Link to={`/newresult/${driver._id}`}><button><Icon name="add" /> Nové hodnocení</button></Link>
            }
            <Link to={`/results?driver=${driver._id}`}><button>Hodnocení řidiče</button></Link>
            {[roles.FLEET_MANAGER, roles.SUPERVISOR, roles.ADMIN].indexOf(viewer.role) !== -1 &&
              <button onClick={this.onDelete.bind(this.props)}>Odstranit</button>
            }
          </div>
          }
        </aside>
        <main className="form-page thin">
            {driverForm}
        </main>
      </div>
    )
  }
}

DriverPage.propTypes = {
  match: React.PropTypes.object.isRequired,
  driver: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object.isRequired,
  loadDriver: React.PropTypes.func.isRequired,
  clearDriver: React.PropTypes.func.isRequired,
  deleteDriver: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  driver: state.drivers.current,
  viewer: state.users.viewer,
}), { loadDriver, clearDriver, deleteDriver })(DriverPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Driver.js